import React from 'react';
import { Row } from 'react-grid-system';
import ConditionalRender from '@Components/ConditionalRender/ConditionalRender';
import AddressOptions from './AddressOptions';
import { SelectedAddressType } from '../ShippingMethod';

interface IAddressBookNotAvailable {
	addressType: SelectedAddressType;
	differentAddress: () => JSX.Element;
	isPrepaidPurchase: boolean | undefined;
	pickupSelector: JSX.Element;
	setAddressType: (type: SelectedAddressType) => void;
}

const AddressBookNotAvailable = ({
	addressType,
	differentAddress,
	isPrepaidPurchase,
	pickupSelector,
	setAddressType,
}: IAddressBookNotAvailable): JSX.Element => (
	<>
		<Row>{pickupSelector}</Row>
		<ConditionalRender
			show={addressType === SelectedAddressType.DIFFERENT || addressType === SelectedAddressType.ADRESS_BOOK}
			onTrue={() => differentAddress()}
			onFalse={() => (
				<Row>
					<ConditionalRender
						show={addressType !== SelectedAddressType.OUTLET}
						onTrue={() => (
							<AddressOptions
								addressType={addressType}
								isPrepaidPurchase={isPrepaidPurchase}
								differentAddress={differentAddress}
								setAddressType={setAddressType}
							/>
						)}
					/>
				</Row>
			)}
		/>
	</>
);

export default AddressBookNotAvailable;
